<template>
    <button-list v-bind:items="buttons" v-bind:value="value" v-bind:onclick="onclick"/>
</template>

<script>

    import ButtonList from "./ButtonList.vue"

    export default {
        name: "YesNoButtonList",
        components: {
            ButtonList
        },
        data: function() {
            return {
                buttons: [
                    { text: "Yes", value: true },
                    { text: "No", value: false }
                ]
            }
        },
        props: {
            value: null,
            onclick: Function
        }
    }
</script>
